<template>
  <div class="row">
    <div class="col-12">
      <svg class="network-diagram" v-bind:style="{ height: this.height + 'px' }">
        <g v-bind:transform="transform">
          <network-diagram-tree
            v-bind:network-id="networkId"
            v-bind:root="deviceTree"
            v-bind:index="0"
            v-on:tree-width-changed="onTreeWidthChange" />
        </g>
      </svg>
      <vue-context ref="menu">
        <ul slot-scope="menu">
          <template v-if="menu.data!=null&&menu.data.source=='node'">
            <li v-on:click="addNode(menu.data.nodeId)">この下にノードを追加</li>
            <li v-if="menu.data.nodeId!=0" v-on:click="editNode(menu.data.nodeId)">このノードを編集</li>
            <li v-if="menu.data.nodeId!=0" v-on:click="deleteNode(menu.data.nodeId)">このノードを削除</li>
          </template>
          <li v-if="menu.data!=null&&menu.data.source=='cable'" v-on:click="insertNode(menu.data.childNodeId)">ここにノードを挿入</li>
        </ul>
      </vue-context>
    </div>
  </div>
</template>

<script>
  import { VueContext } from 'vue-context'
  import NetworkDiagramTree from './NetworkDiagramTree'

  import Vue from 'vue'
  import EventHub from './EventHub'
  Vue.use(EventHub);

  export default {
    props: {
      //networkId: String,
      deviceTree: Object,
    },
    components: { NetworkDiagramTree, VueContext },
    mounted: function () {
      this.$eventHub.$on('node-contextmenu-requested', this.onNodeContextmenuRequest);
      this.$eventHub.$on('cable-contextmenu-requested', this.onCableContextmenuRequest)
    },
    data: function () {
      return {
        rootX: 100,
        rootY: 100,
        height: 0,
        networkId: '',
      }
    },
    computed: {
      transform: function () {
        return 'translate(' + this.rootX + ',' + this.rootY + ')'
      }
    },
    methods: {
      onTreeWidthChange: function (param) {
        this.height = this.rootY + param.treeWidth;
      },
      onNodeContextmenuRequest: function (nodeId, event) {
        this.$refs.menu.open(event, { source: 'node', nodeId });
      },
      onCableContextmenuRequest: function (childNodeId, event) {
        this.$refs.menu.open(event, { source: 'cable', childNodeId });
      },
      addNode: function (parentId) {
        location.href = '/network/' + this.networkId + '/node?parent=' + parentId;
      },
      insertNode: function (childId) {
        location.href = '/network/' + this.networkId + '/node?child=' + childId;
      },
      editNode: function (nodeId) {
        location.href = '/network/' + this.networkId + '/node/' + nodeId;
      },
      deleteNode: function (nodeId) {
        /*axios.delete('/network/' + this.networkId + '/node/' + nodeId)
          .then(() => {
            location.reload(true);
          });*/
      }
    }
  }
</script>

<style lang="sass" scoped>
  .network-diagram
    width: 100%
</style>
